<template>
  <div id="initialLoader">
    <div class="loader-spinner" />
  </div>
</template>

<script setup lang="ts">
</script>
